<template>
    <div>
        <delivery-picker
            :shipment-city="shipmentCity"
            :bounds="bounds"
            :is-operator="isOperator"
            :is-need-geocode="isPolygonsInRegion"
            @shipment-city-selected="onShipmentCitySelected"
            @address-changed="onAddressChanged"
            ref="deliveryPicker"
            :is-disabled="carsLoading"
            :currentRegionUid="currentRegionUid"
            :distanceToWarehouse="distanceToWarehouse"
            :deliveryCalculator1C="deliveryCalculator1C"
            :deliveryCallToActionText="deliveryCallToActionText"
            :carsForCityAndAddress="carsForCityAndAddress"
        >

        </delivery-picker>

        <section class="container">
            <div class="row">
                <delivery-cars
                    v-if="!carsLoading"
                    :is-operator="isOperator"
                    :cars-for-city="c_carsForCity"
                    :cars-for-city-and-address="c_carsForCityAndAddress"
                    :isHidePrice="isPriceHidden"
                    :hiddenPriceMessage="hiddenPriceText"
                >
                    <template #table-city-dynamic-title>
                        Стоимость доставки в филиале {{ shipmentCity.REGION_NAME_DECLINE_RP }}
                    </template>
                </delivery-cars>

                <div class="col-lg-8 col-md-12 no-cars-available-message" v-if="isShowContactPhone && !carsLoading">
                    <strong class="pb-3 d-block">Стоимость доставки по указанному адресу:</strong>
                    <div class="alert alert-warning font-bold delivery-page__alert" role="alert" v-if="!isOperator">
                        <i class="icn-warning-color"></i>
                        <div>
                            Ошибка! После оформления заказа с вами свяжется оператор для уточнения условий доставки
                        </div>
                    </div>
                    <div class="alert alert-warning font-bold delivery-page__alert" role="alert" v-else>
                        <i class="icn-warning-color"></i>
                        {{ deliveryErrorMessage }}
                    </div>
                </div>

                <div v-if="carsLoading" class="col-md-12 col-lg-8">
                    <liner-progressbar sProgressbarVal="100"> </liner-progressbar>
                </div>
            </div>
        </section>

        <operator-debug id="operator_debug" :debug-html="debugHTML + debugRouteMessage" v-show="isAdmin" />
    </div>
</template>

<script>
import DeliveryPicker from "./components/DeliveryPicker";
import DeliveryCars from "./components/DeliveryCars";
import OperatorDebug from "./components/Operator/OperatorDebug.vue";

const Mode = {
    CarsForCity: Symbol("CarsForCity"),
    CarsForCityAndAddress: Symbol("CarsForCityAndAddress"),
};

export default {
    name: "App",

    data() {
        return {
            /** Город отгрузки,
             * начальное берётся из JS_DATA */
            shipmentCity: this.$root.JS_DATA.CURRENT_LOCATION,

            /** Координаты, города отгрузки,
             * начальное берётся из JS_DATA */
            bounds: this.$root.JS_DATA.BOUNDS,

            currentRegionUid: this.$root.JS_DATA.curentRegionUid,

            deliveryCalculator1C: this.$root.JS_DATA.deliveryCalculator1C,

            /** Список машин для города отгрузки */
            carsForCity: Object.values(this.$root.JS_DATA.DELIVERY_CARLIST),

            /** Список машин для города отгрузки и выбранного адреса доставки */
            carsForCityAndAddress: [],

            /** Режим отображения: для города отгрузки, для адреса доставки, ... */
            mode: Mode.CarsForCity,

            /** Адрес доставки (объект с полями addressText, data)
             * Из data используются .city, .coords */
            deliveryAddress: null,

            /** Индикатор загрузки вариантов доставки **/
            carsLoading: false,

            /** Расстояние от склада */
            distanceToWarehouse: "",

            // Перенёс со старого:
            debugHTML: "",

            // Ошибка при построении маршрута
            debugRouteMessage: "",

            // Скрыта ли цена:
            isPriceHidden: this.$root.JS_DATA.IS_PRICE_HIDDEN,

            // Текст, отображаемый при скрытии цен:
            hiddenPriceText: this.$root.JS_DATA.PRICE_HIDDEN_TEXT,
            // получен ли ответ на запрос машин из 1С
            isRequestForCarsSended: false,
            //Получение текста элемента ИБ Включаемые области
            deliveryCallToActionText: this.$root.JS_DATA.DELIVERY_CALL_TO_ACTION,
        };
    },

    computed: {
        /**
         * функция помогает блокировать кнопку показать на карте
         * @returns {{"data-bs-target": string, "data-bs-toggle": string}}
         */
        openPopupMapButtonAttrs() {
            return this.carsLoading ? {} : { "data-bs-toggle": "modal", "data-bs-target": "#popupDelivery" };
        },
        /**
         * Есть ли полигоны доставки в выбранном регионе
         * */
        isPolygonsInRegion() {
            if (!this.shipmentCity || !this.$root.JS_DATA.DELIVERY_POLYGONS) {
                return false;
            }
            let city = this.shipmentCity;
            let polygon = this.$root.JS_DATA.DELIVERY_POLYGONS.find(function (polygon) {
                return polygon.UF_REGION_UID === city.STORE.XML_ID;
            });
            return !!polygon;
        },
        isShowContactPhone() {
            let sResult =
                !this.newDeliveryScheme || (this.isRequestForCarsSended && !this.isAddressEmpty() && !this.isHaveCars);
            return sResult;
        },
        /**
         * Признак NEW_DELIVERY_SCHEME
         * true, если филиал работает по прайсу доставки из 1С
         * */
        newDeliveryScheme() {
            return this.shipmentCity.NEW_DELIVERY_SCHEME === "Y";
        },

        /** Признак Оператор */
        isOperator() {
            return this.$root.JS_DATA.isOperator;
        },

        /** Признак Администратор */
        isAdmin() {
            return this.$root.JS_DATA.isAdmin;
        },

        /** Сообщение об ошибке получения вариантов доставки */
        deliveryErrorMessage() {
            if (this.deliveryCalculator1C) {
                var errorText = "По маршруту не удалось произвести расчет";
            } else {
                var errorText = "Для данного филиала алгоритм расчета доставки на сайте не используется";
            }
            return errorText;
        },

        /** Должно быть заполнено только одно, которое нужно отображать */

        c_carsForCityAndAddress() {
            if (this.mode == Mode.CarsForCityAndAddress) return this.carsForCityAndAddress;
            else return [];
        },

        c_carsForCity() {
            if (this.mode == Mode.CarsForCity) return this.carsForCity;
            else return [];
        },

        isHaveCars() {
            return this.c_carsForCityAndAddress.length > 0 || this.c_carsForCity.length > 0;
        },

        /** Включаемые области */

        infoConditions() {
            if (!this.newDeliveryScheme) {
                return this.infoOldScheme;
            }
            try {
                return this.$root.JS_DATA.INCLUDES.INFO_CONDITIONS;
            } catch (e) {
                console.error(e);
                return "";
            }
        },

        infoOldScheme() {
            try {
                return this.$root.JS_DATA.INCLUDES.INFO_OLD_SCHEME;
            } catch (e) {
                console.error(e);
                return "";
            }
        },

        infoText() {
            try {
                return this.$root.JS_DATA.INCLUDES.INFO_TEXT;
            } catch (e) {
                console.error(e);
                return "";
            }
        },
    },

    methods: {
        /** Выбран город отгрузки */
        async onShipmentCitySelected(city) {
            this.shipmentCity = city;
            this.setYandexMapCoords(city.LAT, city.LON);
            if (city.STORE && city.STORE.XML_ID) {
                this.currentRegionUid = city.STORE.XML_ID;
            }
            gaPush.sendToGA("ga_event_ni", "delivery", "changeGeoSuccess", city.CITY_NAME, {
                dimension7: window.dimension7,
                dimension11: window.defaultCity,
            });
            await this.onInfoUpdated();
        },

        isAddressEmpty: function isAddressEmpty() {
            if (this.deliveryAddress) {
                return this.deliveryAddress.addressText === "";
            }
            return true;
        },

        /**
         * Объект Яндекс.Карты
         */
        getYandexMap() {
            return this.$refs.deliveryPicker.$refs.mapPopup.$refs.yandexMap;
        },

        /**
         * Обновление отображения карты
         */
        setYandexMapCoords(lat, lon) {
            this.getYandexMap().yaMap.setCenter([parseFloat(lat), parseFloat(lon)]);
        },

        /**
         * Очистка объектов
         */
        removeAllYandexMapPlaceMark() {
            this.getYandexMap().yaMap.geoObjects.removeAll();
            this.getYandexMap().changeRegionPolygon(this.shipmentCity.STORE.XML_ID);
            this.setYandexMapCoords(this.shipmentCity.LAT, this.shipmentCity.LON);
        },

        /** Изменён адрес доставки */
        onAddressChanged(address) {
            this.deliveryAddress = address;
            this.onInfoUpdated();
        },

        /** Удаление данных о доставке */
        resetDeliveryResult() {
            this.deliveryAddress = null;
            this.carsForCityAndAddress = [];
            this.carsLoading = false;
            this.distanceToWarehouse = "";
        },

        /** Отправка событиый в Google Analytics */
        sendToGA(event, eventAction, eventLabel) {
            gaPush.sendToGA(
                event,
                document.querySelector('[data-bs-target="#modal-shipment-cities"]') != null ? "delivery" : "order",
                eventAction,
                eventLabel,
                {
                    dimension7: window.dimension7,
                    dimension11: window.dimension11,
                    dimension15: localStorage.getItem("deliveryAddress")
                        ? localStorage.getItem("deliveryAddress")
                        : document.querySelector("#suggest").value,
                }
            );
        },
        /** Изменился город или адрес */
        async onInfoUpdated() {
          const address = this.deliveryAddress;
          /** Выбран адрес доставки */

          if (!address || (typeof address.addressText == 'undefined' || address.addressText == '')) {
            this.resetDeliveryResult();
          } else if (this.deliveryCalculator1C) {
            return await this.dadataDelivery();
          } else {
            return await this.yandexDelivery();
          }
        },
      async dadataDelivery() {
        const self = this;
        const address = self.deliveryAddress;
        self.carsLoading = true;
        localStorage.removeItem("isNeedSetPlacemark");
        let yandexMap = this.getYandexMap();
        let coords = yandexMap.lastClickCoords;
        yandexMap.lastClickCoords = null;
        let toAddress = address.addressTextFor1C;
        if (!address.data) {
          self.resetDeliveryResult();
        }
        else if (address.data.cars) {
          self.carsForCityAndAddress = address.data.cars;
          self.distanceToWarehouse = address.data.distance;
          self.mode = Mode.CarsForCityAndAddress;
          self.isRequestForCarsSended = true;
          self.writeDeliveryMonitorForm();
          self.carsLoading = false;
        }
        else {
          BX.ajax
              .runComponentAction("evraz.main:delivery.calculator", "getDeliveryCars", {
                mode: "class",
                data: {
                  regionUid: this.currentRegionUid,
                  geo_point: coords ? coords : [],
                  address: coords ? "" : toAddress,
                  type: address.data.geoType ? address.data.geoType : "geo",
                  basket: "N",
                },
              })
              .then(function (resultCarsAction) {
                if (resultCarsAction.data.address !== "") {
                  self.sendToGA("GAevent", "inputAddress", resultCarsAction.data.address);
                }
                let distance = resultCarsAction.data.distance
                    ? parseFloat(resultCarsAction.data.distance.replace(/\s/g, ""))
                    : 0;
                if (distance > 0 && resultCarsAction.data.cars.length === 0) {
                  self.sendToGA("GAevent", "distanceCostError", resultCarsAction.data.distance);
                } else {
                  if (distance > 0) {
                    self.sendToGA("GAevent", "distanceSuccess", resultCarsAction.data.distance);
                  } else {
                    self.sendToGA("GAevent", "distanceError", window.dimension11);
                  }
                  if (resultCarsAction.data.cars.length > 0) {
                    self.sendToGA("ga_event_ni", "costSuccess", window.dimension11);
                  } else {
                    self.sendToGA("ga_event_ni", "costError", window.dimension11);
                  }
                }
                self.carsForCityAndAddress = resultCarsAction.data.cars;
                self.distanceToWarehouse = resultCarsAction.data.distance;
                self.mode = Mode.CarsForCityAndAddress;
                self.isRequestForCarsSended = true;

                self.writeDeliveryMonitorForm();
                self.carsLoading = false;
              })
              .catch(function (e) {
                self.carsForCityAndAddress = [];
                self.isRequestForCarsSended = true;
                self.carsLoading = false;
              });
        }
        return;
      },
      async yandexDelivery() {
        const self = this;
        const address = self.deliveryAddress;

        /** Если запрос к геокодеру не требуется */
        if (!this.isPolygonsInRegion && address) {
          let toAddress = address.addressText;
          if(toAddress) {
            self.sendToGA(
                'GAevent',
                'inputAddress',
                toAddress
            );
            this.distanceToWarehouse = await this.findDistance(
                [this.shipmentCity.LAT, this.shipmentCity.LON],
                toAddress
            ).catch((e) => {
              if (this.isAdmin) {
                this.debugRouteMessage = e;
              }
              self.sendToGA(
                  'GAevent',
                  'distanceError',
                  window.dimension11
              );
            });
          }
          if (address.data != null) {
            if (this.distanceToWarehouse) {
              self.sendToGA(
                  'GAevent',
                  'distanceSuccess',
                  this.distanceToWarehouse
              );
            }
            const selectedZoneId = this.getYandexMap().selectedZoneUID;
            const coords = address.data.coords.join(',');

            const data = await BX.Evraz.deliveryApi.getCarsForCalculator({
              city_from: this.shipmentCity.CITY_NAME,
              city_dest: address.data.city,
              address: address.addressText,
              distance: this.distanceToWarehouse,
              coords: coords,
              selectedZoneUID: selectedZoneId,
            });

            if (data.debugHtml) {
              this.debugHTML = data.debugHtml;
            }
            this.carsForCityAndAddress = data.cars;
            if (this.carsForCityAndAddress) {
              self.sendToGA(
                  'ga_event_ni',
                  'costSuccess',
                  window.dimension11
              );
            } else {
              self.sendToGA(
                  'ga_event_ni',
                  'costError',
                  window.dimension11
              );
            }
            this.mode = Mode.CarsForCityAndAddress;

            this.isRequestForCarsSended = true;
            this.writeDeliveryMonitorForm();
          }
          return;
        }

        localStorage.removeItem("isNeedSetPlacemark");
        /** Если требуется запрос к геокодеру */
        if (address && address.data) {
          let toAddress = address.addressText;
          self.sendToGA(
              'GAevent',
              'inputAddress',
              toAddress
          );

          // если есть адрес и нет координат, получим их
          if (!address.data.coords) {
            let coords = await BX.Evraz.getCoordsByAddress(toAddress, this, false, callbackError);

            function callbackError(err) {
              console.log(err);
            }

            address.data.coords =
                coords.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos
                    .split(" ")
                    .reverse();
          }

          if (address.data.coords && address.data.coords.length === 2 && address.data.coords[0] != null) {
            toAddress = address.data.coords;
          }

          await this.findDistance(
              [this.shipmentCity.LAT, this.shipmentCity.LON],
              toAddress
          ).then(function (distance) {
            self.sendToGA(
                'GAevent',
                'distanceSuccess',
                window.dimension11
            );
            self.distanceToWarehouse = distance;
          }).catch((e) => {
            console.error("catch", e);
            self.sendToGA(
                'GAevent',
                'distanceError',
                window.dimension11
            );
            if (this.isAdmin) {
              this.debugRouteMessage = e;
            }
          });

          var selectedZoneId = this.getYandexMap().findPolygon(address.data.coords);

          const data = await BX.Evraz.deliveryApi.getCarsForCalculator({
            city_from: this.shipmentCity.CITY_NAME,
            city_dest: address.data.city,
            address: address.addressText,
            distance: this.distanceToWarehouse,
            coords:
                address.data.coords && address.data.coords.length === 2 ? address.data.coords.join() : "",
            selectedZoneUID: selectedZoneId,
          });
          if (data.debugHtml) {
            this.debugHTML = data.debugHtml;
          }

          this.carsForCityAndAddress = data.cars;
          if (this.carsForCityAndAddress) {
            self.sendToGA(
                'ga_event_ni',
                'costSuccess',
                window.dimension11
            );
          } else {
            self.sendToGA(
                'ga_event_ni',
                'costError',
                window.dimension11
            );
          }
          this.mode = Mode.CarsForCityAndAddress;

          this.isRequestForCarsSended = true;

          this.writeDeliveryMonitorForm();
        }
        else {
          if (address) {
            if (!address.addressText) {
              this.removeAllYandexMapPlaceMark();
            }
          } else {
            this.removeAllYandexMapPlaceMark();
          }
          this.mode = Mode.CarsForCity;
        }
      },
        async findDistance(a, b) {
            return await this.getYandexMap().findRouteDistance(a, b);
        },

        async writeDeliveryMonitorForm() {
            const address = this.deliveryAddress;
            var pointAddress = document.getElementById("point_address");
            if (pointAddress && address.addressText) {
                pointAddress.value = address.addressText;
            }
            var pointDistance = document.getElementById("point_distance");
            if (pointDistance && this.distanceToWarehouse) {
                pointDistance.value = this.distanceToWarehouse;
            }
            var pointCityDest = document.getElementById("point_city_dest");
            if (pointCityDest) {
                if (address.data.city) {
                    pointCityDest.value = address.data.city;
                } else {
                    pointCityDest.value = "";
                }
            }
            var pointLat = document.getElementById("point_lat");
            if (pointLat && address.data.coords) {
                pointLat.value = address.data.coords[0];
            }
            var pointLon = document.getElementById("point_lon");
            if (pointLon && address.data.coords) {
                pointLon.value = address.data.coords[1];
            }
            var pointRegion = document.getElementById("point_region");
            if (pointRegion && this.shipmentCity.CITY_NAME) {
                pointRegion.value = this.shipmentCity.CITY_NAME;
            }
        },
    },

    components: { DeliveryPicker, DeliveryCars, OperatorDebug },
};
</script>

<style scoped>
.delivery-info__content strong {
    font-weight: 500;
}

.no-cars-available-message {
    margin-top: 20px;
}
.progress{
  margin: 17px 0;
}
h2, >>> h2 {
  margin-bottom: 24px;
}
</style>
